export const selectConfigurationParameterById = (state, id) =>
  state.dbConfigurations.find((elem) => elem.detailId === id);

export const isOtpActive = (state, id) =>
  state.dbConfigurations.some(
    (elem) => elem.detailId === id && elem.value === 'Y',
  );

export const isAnyOtpActive = (state) =>
  state.dbConfigurations.some(
    (elem) => elem.detailId.includes('ENFORCE_OTP') && elem.value === 'Y',
  );
